document.addEventListener('DOMContentLoaded', function() {
    const breakpoint = 640;
    const container = document.querySelector('.imagecardelement-cards');
    const controls = document.querySelector('.imagecardelement-slider-controls');

    if (!container) return;

    let swiperInstance = null;
    let originalCards = null;

    function initSwiper() {
        if (!originalCards) {
            originalCards = Array.from(container.children);
        }

        container.classList.add('swiper-container');
        const wrapper = document.createElement('div');
        wrapper.classList.add('swiper-wrapper');
        
        originalCards.forEach(card => {
            const slide = card.cloneNode(true);
            slide.classList.add('swiper-slide');
            wrapper.appendChild(slide);
        });
        
        container.innerHTML = '';
        container.appendChild(wrapper);

	        swiperInstance = new Swiper('.swiper-container', {
	            slidesPerView: 1,
	            spaceBetween: 20,
	            loop: true,
	            centeredSlides: true,
            pagination: {
                el: '[data-imagecardelement-dots]',
                clickable: true,
                bulletClass: 'imagecardelement-slider-dot',
                bulletActiveClass: 'imagecardelement-slider-dot--active',
            },
            navigation: {
                nextEl: '[data-imagecardelement-next]',
	                prevEl: '[data-imagecardelement-prev]',
	            },
	        });

	        syncPaginationScroll(false);
	        swiperInstance.on('slideChange', function () {
	            syncPaginationScroll(true);
	        });
	        swiperInstance.on('transitionEnd', function () {
	            syncPaginationScroll(true);
	        });
	        swiperInstance.on('paginationUpdate', function () {
	            syncPaginationScroll(true);
	        });

	        if (controls) {
	            controls.style.display = 'flex';
	        }
	    }

	    function syncPaginationScroll(animated) {
	        if (!controls) return;

	        const dots = controls.querySelector('[data-imagecardelement-dots]');
	        const activeDot = dots ? dots.querySelector('.imagecardelement-slider-dot--active') : null;

	        if (!dots || !activeDot) return;

	        window.requestAnimationFrame(function () {
	            const edgeGap = 8;
	            const visibleLeft = dots.scrollLeft;
	            const visibleRight = visibleLeft + dots.clientWidth;
	            const activeLeft = activeDot.offsetLeft;
	            const activeRight = activeLeft + activeDot.offsetWidth;
	            let targetLeft = visibleLeft;

	            if (activeRight > visibleRight - edgeGap) {
	                targetLeft = visibleLeft + (activeRight - visibleRight) + edgeGap;
	            } else if (activeLeft < visibleLeft + edgeGap) {
	                targetLeft = activeLeft - edgeGap;
	            }

	            dots.scrollTo({
	                left: Math.max(0, targetLeft),
	                behavior: animated ? 'smooth' : 'auto'
	            });
	        });
	    }

    function destroySwiper() {
        if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }

        container.classList.remove('swiper-container');
        container.innerHTML = '';
        originalCards.forEach(card => {
            container.appendChild(card.cloneNode(true));
        });

        if (controls) {
            controls.style.display = 'none';
        }
    }

    function handleResize() {
        if (window.innerWidth <= breakpoint) {
            if (!swiperInstance) {
                initSwiper();
            }
        } else {
            if (swiperInstance) {
                destroySwiper();
            }
        }
    }

    handleResize();

    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(handleResize, 250);
    });
});
